import React, { useEffect, useState } from "react";
import useWindowDimensions from "./components/util/useWindowDimensions";
import styles from "./App.module.css";
import Header from "./components/header/Header";
import NavBar from "./components/section/NavBar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "./components/pages/mainpage/MainPage";
import Statement from "./components/pages/statement/Statement";
import { useScrollbarWidth } from "./components/util/useScrollbarWidth";
import Ausstellung from "./components/pages/ausstellung/Ausstellung";
import Vita from "./components/pages/vita/Vita";
import Impressum from "./components/pages/impressum/Impressum";
import Datenschutz from "./components/pages/datenschutz/Datenschutz";
import Aktuelles from "./components/pages/aktuelles/Aktuelles";
import Kontakt from "./components/pages/kontakt/Kontakt";
import { getPages } from "./components/util/api";
import Dashboard from "./components/pages/dashboard/Dashboard";
import { Page } from "./types";

const App = () => {
  const { width, height } = useWindowDimensions();
  const [selected, setSelected] = useState(0);
  const [pageData, setPageData] = useState<Page[]>([]);
  const scrollbarWidth = useScrollbarWidth();

  useEffect(() => {
    getPages()
      .then((data) => {
        setPageData(data.pages);
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const arbeitenData =
    pageData.find((page) => page.title === "Arbeiten")?.sections || [];
  const vitaData =
    pageData.find((page) => page.title === "Vita")?.sections || [];
  const ausstellungenData =
    pageData.find((page) => page.title === "Ausstellung")?.sections || [];
  const statementData =
    pageData.find((page) => page.title === "Statement")?.sections || [];
  const aktuellesData =
    pageData.find((page) => page.title === "Aktuelles")?.sections || [];

  return (
    <BrowserRouter>
      <div
        style={{
          width: width - scrollbarWidth - 1,
          height,
        }}
      >
        <div className={styles.main}>
          <Header />
          <div className={styles.wrapper}>
            <NavBar selectedTab={selected} onTabChange={setSelected} />
            <Routes>
              <Route path="/" element={<MainPage data={arbeitenData} />} />
              <Route
                path="/vita"
                element={<Vita data={vitaData} bgData={arbeitenData} />}
              />
              <Route
                path="/ausstellungen"
                element={
                  <Ausstellung data={ausstellungenData} bgData={arbeitenData} />
                }
              />
              <Route
                path="/statement"
                element={
                  <Statement data={statementData} bgData={arbeitenData} />
                }
              />
              <Route
                path="/aktuelles"
                element={
                  <Aktuelles data={aktuellesData} bgData={arbeitenData} />
                }
              />
              <Route
                path="/kontakt"
                element={<Kontakt bgData={arbeitenData} />}
              />
              <Route
                path="/impressum"
                element={<Impressum bgData={arbeitenData} />}
              />
              <Route
                path="/datenschutz"
                element={<Datenschutz bgData={arbeitenData} />}
              />
              <Route
                path="dashboard"
                element={<Dashboard currentData={pageData} />}
              />
            </Routes>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
